'use client';

interface FeedFilterBarProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const FILTERS = [
  { id: 'for-you', label: 'For You' },
  { id: 'following', label: 'Following' },
  { id: 'trending', label: 'Trending' },
  { id: 'new', label: 'New' },
  { id: 'ai-tools', label: '#ai-tools' },
  { id: 'distributed-systems', label: '#distributed-systems' },
  { id: 'ux-design', label: '#ux-design' },
];

export default function FeedFilterBar({ activeFilter, onFilterChange }: FeedFilterBarProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-none">
      {FILTERS.map((filter) => (
        <button
          key={`filter-${filter.id}`}
          onClick={() => onFilterChange(filter.id)}
          className={`flex-shrink-0 px-3 py-1.5 rounded-lg text-sm font-500 transition-all duration-150 ${
            activeFilter === filter.id
              ? 'bg-primary/20 text-accent border border-primary/30' :'text-muted-foreground hover:text-foreground hover:bg-muted border border-transparent'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
}